// Generated by purs version 0.14.3
"use strict";
var Data_Foldable = require("../Data.Foldable/index.js");
var Data_Identity = require("../Data.Identity/index.js");
var Data_Newtype = require("../Data.Newtype/index.js");
var Data_Profunctor = require("../Data.Profunctor/index.js");
var Data_Show = require("../Data.Show/index.js");
var Data_Traversable = require("../Data.Traversable/index.js");
var Tagged = function (x) {
    return x;
};
var untagged = function (v) {
    return v;
};
var traversableTagged = Data_Traversable.traversableIdentity;
var tagged = function (a) {
    return a;
};
var showTagged = function (dictShow) {
    return new Data_Show.Show(function (x) {
        return "(tagged " + (Data_Show.show(dictShow)(untagged(x)) + ")");
    });
};
var semiringTagged = function (dictSemiring) {
    return Data_Identity.semiringIdentity(dictSemiring);
};
var semigroupTagged = function (dictSemigroup) {
    return Data_Identity.semigroupIdenity(dictSemigroup);
};
var ringTagged = function (dictRing) {
    return Data_Identity.ringIdentity(dictRing);
};
var profunctorTagged = new Data_Profunctor.Profunctor(function (v) {
    return function (g) {
        return function (v1) {
            return g(v1);
        };
    };
});
var ordTagged = function (dictOrd) {
    return Data_Identity.ordIdentity(dictOrd);
};
var newtypeTagged = new Data_Newtype.Newtype(function () {
    return undefined;
});
var monoidTagged = function (dictMonoid) {
    return Data_Identity.monoidIdentity(dictMonoid);
};
var monadTagged = Data_Identity.monadIdentity;
var invariantTagged = Data_Identity.invariantIdentity;
var heytingAlgebraTagged = function (dictHeytingAlgebra) {
    return Data_Identity.heytingAlgebraIdentity(dictHeytingAlgebra);
};
var functorTagged = Data_Identity.functorIdentity;
var foldableTagged = Data_Foldable.foldableIdentity;
var extendTagged = Data_Identity.extendIdentity;
var euclideanRingTagged = function (dictEuclideanRing) {
    return Data_Identity.euclideanRingIdentity(dictEuclideanRing);
};
var eqTagged = function (dictEq) {
    return Data_Identity.eqIdentity(dictEq);
};
var comonadTagged = Data_Identity.comonadIdentity;
var commutativeRingTagged = function (dictCommutativeRing) {
    return Data_Identity.commutativeRingIdentity(dictCommutativeRing);
};
var boundedTagged = function (dictBounded) {
    return Data_Identity.boundedIdentity(dictBounded);
};
var booleanAlgebraTagged = function (dictBooleanAlgebra) {
    return Data_Identity.booleanAlgebraIdentity(dictBooleanAlgebra);
};
var bindTagged = Data_Identity.bindIdentity;
var applyTagged = Data_Identity.applyIdentity;
var applicativeTagged = Data_Identity.applicativeIdentity;
var altTagged = Data_Identity.altIdentity;
module.exports = {
    tagged: tagged,
    untagged: untagged,
    newtypeTagged: newtypeTagged,
    showTagged: showTagged,
    traversableTagged: traversableTagged,
    foldableTagged: foldableTagged,
    comonadTagged: comonadTagged,
    extendTagged: extendTagged,
    monadTagged: monadTagged,
    bindTagged: bindTagged,
    applicativeTagged: applicativeTagged,
    applyTagged: applyTagged,
    altTagged: altTagged,
    invariantTagged: invariantTagged,
    functorTagged: functorTagged,
    commutativeRingTagged: commutativeRingTagged,
    ringTagged: ringTagged,
    euclideanRingTagged: euclideanRingTagged,
    semiringTagged: semiringTagged,
    monoidTagged: monoidTagged,
    semigroupTagged: semigroupTagged,
    booleanAlgebraTagged: booleanAlgebraTagged,
    heytingAlgebraTagged: heytingAlgebraTagged,
    boundedTagged: boundedTagged,
    ordTagged: ordTagged,
    eqTagged: eqTagged,
    profunctorTagged: profunctorTagged
};
